/* playTeads handler */
import Container from '@components/atoms/container/adsContainer';
import Event from '@shared/classes/event';
import TeadsUtils, { Placement } from '@shared/utils/teads';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useRef } from 'react';

export default function PlayTeadsHandler({ asset }: { asset?: Event }) {
  const { playAd } = useAppSelector(adsSelector);
  const inplayPlacement = useRef<any>(null);

  useEffect(() => {
    if (!window.teads?.SDK) return;
    const { sdkInstance, placementInstance } = TeadsUtils.initializeTeads({
      asset: asset,
      containerId: 'play-teads-container',
      placementId: 250077,
      placementType: Placement.IN_PLAY,
      videoId: 'video',
    });
    inplayPlacement.current = placementInstance;
    return () => {
      sdkInstance?.destroy?.();
    };
  }, []);

  useEffect(() => {
    if (playAd?.active) {
      if (!inplayPlacement.current?.isAdReady) {
        inplayPlacement.current.loadAd();
      } else {
        inplayPlacement.current.playAd();
      }
    } else {
      inplayPlacement.current.stopAd();
    }
  }, [playAd]);

  return (
    <Container transparent>
      <div
        style={{ width: '100%', height: '100%' }}
        id={'play-teads-container'}
      />
    </Container>
  );
}
